import React, { ReactNode } from "react";
import Step from "src/shared/forms/steps/Step";
import Steps, { IStepsFormProps } from "src/shared/forms/steps/Steps";
import { FormattedMessage } from "react-intl";
import MerchantGroupNameInput from "./inputs/MerchantGroupNameInput";
import MerchantGroupWebsiteInput from "./inputs/MerchantGroupWebsiteInput";
import ContactAddressForm from "src/shared/contacts/forms/ContactAddressForm";
import ContactContactForm from "src/shared/contacts/forms/ContactContactForm";
import EmptyTooltip from "src/shared/forms/tooltips/EmptyTooltip";
import CheckboxInputOld from "src/shared/forms/inputs/CheckboxInputOld";
import type MerchantGroup from "src/merchantgroups/objects/MerchantGroup";

export const MERCHANT_GROUP_NAME = "merchantGroupName";
export const MERCHANT_GROUP_IS_AGENCY = "isAgency";
export const MERCHANT_GROUP_WEBSITE = "webSite";

export interface IMerchantGroupFormProps extends IStepsFormProps {
  merchantGroup?: MerchantGroup;
  form: string;
  children?: ReactNode;
}

export const MerchantGroupForm = ({
  merchantGroup,
  children,
  form,
  ...rest
}: IMerchantGroupFormProps) => {
  return (
    <>
      <Steps {...rest} lastStepRender={children}>
        <Step name={<FormattedMessage id="merchant_groups.form.basic" />}>
          {() => (
            <>
              <MerchantGroupNameInput
                inputID={MERCHANT_GROUP_NAME}
                tooltip={<EmptyTooltip />}
              />

              <div className="my-4">
                <CheckboxInputOld
                  inputID={MERCHANT_GROUP_IS_AGENCY}
                  label={<FormattedMessage id="merchantGroups.isAgency" />}
                  disabled={Boolean(merchantGroup)}
                />
              </div>

              <MerchantGroupWebsiteInput inputID={MERCHANT_GROUP_WEBSITE} />
            </>
          )}
        </Step>

        <Step name={<FormattedMessage id="merchant_groups.form.address" />}>
          {() => <ContactAddressForm form={form} />}
        </Step>

        <Step name={<FormattedMessage id="merchant_groups.form.contact" />}>
          {() => <ContactContactForm />}
        </Step>
      </Steps>
    </>
  );
};
